<ng-template [ngIf]="pageOptions.renderNavBar">
    <pvd-header hide-login="true"></pvd-header>
</ng-template>

<div class="pvd-container-fluid container-divider">
    <h1 class="pvd-heading-XXL" [innerHTML]="pageOptions.title"></h1>
</div>

<div class="pvd-container-fluid container-divider">
    <p [innerHTML]="pageOptions.description" class="description"></p>
    <ng-container >
        <ng-template [ngTemplateOutlet]="TableGrid"></ng-template>
    </ng-container>
</div>

<div class="pvd-container" *ngIf="pageOptions.disclosures" id="disclosures">
    <p class="xsmall color-neutral text-bold" [innerHTML]="pageOptions.disclosures"></p>
    <p *ngIf="pageOptions.eReviewNumber" class="xsmall color-neutral">
        {{ pageOptions.eReviewNumber }}
    </p>
</div>

<ng-template #TableGrid>
    <div class="input-icon-inner search-field">
        <input [formControl]="searchControl" id="fund-search" type="text" class="pvd-input"
            aria-invalid="false" placeholder="Search for Fund" />
        <div *ngIf="spinner" class="spinner-overlay">
            <div class="spinner"></div>
        </div>

        <pvd-icon *ngIf="spinner==false" class="input-icon" icon="search"></pvd-icon>
    </div>

    <div class="table-container">
        <table class="pvd-table-simple table-striped">
            <thead>
                <tr>
                    <th  [ngClass]="isAscSort() ? 'sort-asc' : 'sort-desc'" (click)="toggleSort()">
                        Fund Class/Name
                    </th>
                    <th style="text-align: center;">
                        Summary Prospectus
                    </th>
                    <th style="text-align: center;">
                        Prospectus
                    </th>
                    <th style="text-align: center;">
                        Statement of Additional Info
                    </th>
                    <th style="text-align: center;">
                        Tailored Shareholder Report
                        <sup><a (click)="scrollTo()"
                            (keydown.enter)="scrollTo()"
                            (keydown.space)="scrollTo()"
                            href="javascript:void(0)">1</a></sup>
                    </th>
                    <th style="text-align: center;">
                        Financial Statements & Other Information
                        <sup><a (click)="scrollTo()"
                            (keydown.enter)="scrollTo()"
                            (keydown.space)="scrollTo()"
                            href="javascript:void(0)">2</a></sup>
                    </th>
                    <th style="text-align: center;">
                        Quarterly Holdings Reports
                    </th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="
              let prospectus of allData;
              let i = index;
              trackBy: trackByFn
            ">
                    <td class="table-row-header text-left" [id]="getCusip(prospectus)" [innerHTML]="getFundName(prospectus)"></td>

                    <td style="vertical-align: middle;"  class="text-center">
                        <div *ngIf="prospectus.documents && prospectus.documents.SUMS" id="SUMS">
                            <a [href]="prospectus.documents.SUMS?.encUrlParam" target="popup"
                                (click)="openCusipLinkPopup(prospectus.documents.SUMS?.encUrlParam)">
                                <pvd-icon class="color-link" icon="add-note"></pvd-icon>



                            </a>
                        </div>
                    </td>

                    <td style="vertical-align: middle;" class="text-center">
                        <div *ngIf="prospectus.documents && prospectus.documents.PROS && !prospectus.documents.MPROS" id="PROS">
                            <a [href]="prospectus.documents.PROS?.encUrlParam" target="popup"
                                (click)="openCusipLinkPopup(prospectus.documents.PROS?.encUrlParam)"><pvd-icon
                                    class="input-icon" icon="add-note"></pvd-icon>
                            </a>
                        </div>
                        <div *ngIf="prospectus.documents && prospectus.documents.MPROS" id="MPROS">
                            <a [href]="prospectus.documents.MPROS?.encUrlParam" target="popup"
                                (click)="openCusipLinkPopup(prospectus.documents.MPROS?.encUrlParam)"><pvd-icon
                                    class="input-icon" icon="add-note"></pvd-icon>
                            </a>
                        </div>
                    </td>

                    <td style="vertical-align: middle;" class="text-center">
                        <div *ngIf="prospectus.documents && prospectus.documents.SAI && !prospectus.documents.MSAI" id="SAI">
                            <a [href]="prospectus.documents.SAI?.encUrlParam" target="popup"
                                (click)="openCusipLinkPopup(prospectus.documents.SAI?.encUrlParam)"><pvd-icon
                                    class="input-icon" icon="add-note"></pvd-icon>
                            </a>
                        </div>
                        <div *ngIf="prospectus.documents && prospectus.documents.MSAI" id="MSAI">
                            <a [href]="prospectus.documents.MSAI?.encUrlParam" target="popup"
                                (click)="openCusipLinkPopup(prospectus.documents.MSAI?.encUrlParam)"><pvd-icon
                                    class="input-icon" icon="add-note"></pvd-icon>
                            </a>
                        </div>
                    </td>

                    <td>
                        <div *ngIf="prospectus.documents && prospectus.documents.TSRA" id="TSRA">
                            <a [href]="prospectus.documents.TSRA?.encUrlParam" target="popup"
                                (click)="openCusipLinkPopup(prospectus.documents.TSRA?.encUrlParam)"><pvd-icon
                                    class="input-icon" icon="add-note"></pvd-icon>Annual
                            </a>
                        </div>
                        <div *ngIf="prospectus.documents && prospectus.documents.TSRS" id="TSRS">
                            <a [href]="prospectus.documents.TSRS?.encUrlParam" target="popup"
                                (click)="openCusipLinkPopup(prospectus.documents.TSRS?.encUrlParam)"><pvd-icon
                                    class="input-icon" icon="add-note"></pvd-icon>Semi-Annual
                            </a>
                        </div>
                    </td>
                    <td>
                        <div *ngIf="prospectus.documents && prospectus.documents.ANN && !prospectus.documents.MANN" id="ANN">
                            <a [href]="prospectus.documents.ANN?.encUrlParam" target="popup"
                                (click)="openCusipLinkPopup(prospectus.documents.ANN?.encUrlParam)"><pvd-icon
                                    class="input-icon" icon="add-note"></pvd-icon>Annual
                            </a>
                        </div>
                        <div *ngIf="prospectus.documents && prospectus.documents.MANN" id="MANN">
                            <a [href]="prospectus.documents.MANN?.encUrlParam" target="popup"
                                (click)="openCusipLinkPopup(prospectus.documents.MANN?.encUrlParam)"><pvd-icon
                                    class="input-icon" icon="add-note"></pvd-icon>Annual
                            </a>
                        </div>
                        <div *ngIf="prospectus.documents && prospectus.documents.SEMI && !prospectus.documents.MSEMI" id="SEMI">
                            <a [href]="prospectus.documents.SEMI?.encUrlParam" target="popup"
                                (click)="openCusipLinkPopup(prospectus.documents.SEMI?.encUrlParam)"><pvd-icon
                                    class="input-icon" icon="add-note"></pvd-icon>Semi-Annual
                            </a>
                        </div>
                        <div *ngIf="prospectus.documents && prospectus.documents.MSEMI" id="MSEMI">
                            <a [href]="prospectus.documents.MSEMI?.encUrlParam" target="popup"
                                (click)="openCusipLinkPopup(prospectus.documents.MSEMI?.encUrlParam)"><pvd-icon
                                    class="input-icon" icon="add-note"></pvd-icon>Semi-Annual
                            </a>
                        </div>
                    </td>
                    <td>
                        <div *ngIf="prospectus.documents && prospectus.documents.NPRT1" id="NPRT1">
                            <a [href]="prospectus.documents.NPRT1?.encUrlParam" target="popup" (click)="
                    openCusipLinkPopup(prospectus.documents.NPRT1?.encUrlParam)
                  "><pvd-icon class="input-icon" icon="add-note"></pvd-icon>1st Quarter

                            </a>
                        </div>
                        <div *ngIf="prospectus.documents && prospectus.documents.NPRT3" id="NPRT3">
                            <a [href]="prospectus.documents.NPRT3?.encUrlParam" target="popup" (click)="
                    openCusipLinkPopup(prospectus.documents.NPRT3?.encUrlParam)
                  "><pvd-icon class="input-icon" icon="add-note"></pvd-icon>3rd Quarter

                            </a>
                        </div>
                    </td>
                    </tr>
                <tr *ngIf="!loading && allData?.length == 0" style="text-align: center">
                    <td colspan="9">
                        There are currently no prospectus to display.
                    </td>
                </tr>

                <tr *ngIf="loading" style="text-align: center">
                    <td colspan="9">Loading fund information...</td>
                </tr>
            </tbody>
        </table>
    </div>
    <app-pagination *ngIf="this.query!=null && this.query?.trim().length==0" [currentPage]="currentPage" [totalPages]="totalPages"
        (pageChange)="onPageChange($event)"></app-pagination>
</ng-template>

